<prism-section-header [title]="'Scheduled Jobs'" [breadcrumbs]="breadcrumbs"></prism-section-header>
<div class="row mb-3">
  <div class="col-7">
    <integra-search
      searchViewMode="adv-search-wide"
      [searchConfig]="advSearchConfig"
      placeHolder="Search by Job ID, Job Description,"
      [closeButton]="true"
      (applyFilterEvent)="handleFilterEvent($event)"
    ></integra-search>
  </div>
</div>
<div class="mt-20 d-flex">
  <kendo-grid
    #jobListGrid
    class="grid"
    [height]="height"
    [pageable]="true"
    [loading]="isLoading"
    [data]="{ data: jobsList, total: totalRows }"
    [pageSize]="take"
    [skip]="skip"
    [sortable]="sortSettings"
    [sort]="sortDescriptor"
    [rowClass]="getRowStyle"
    [selectable]="selectableSettings"
    [rowSelected]="isRowSelected"
    kendoGridSelectBy="jobId"
    (pageChange)="handlePageChange($event)"
    (detailExpand)="handleDetailExpand($event)"
    (detailCollapse)="handleDetailCollapse($event)"
    [isDetailExpanded]="isDetailExpanded.bind(this)"
  >
    <kendo-grid-column title="JOB ID" field="jobId"></kendo-grid-column>
    <kendo-grid-column title="JOB TYPE" field="jobType" [width]="150"></kendo-grid-column>
    <kendo-grid-column title="JOB DESCRIPTION" field="jobDesc"></kendo-grid-column>
    <kendo-grid-column title="REQUESTED BY" field="requestedBy"></kendo-grid-column>
    <kendo-grid-column title="DATE/TIME" field="dateTime">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{ dataItem.dateTime | date: 'MM/dd/yyyy h:mm a' : null : dateLocalePipe }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="STATUS" field="status" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <prism-pill [status]="dataItem.status"></prism-pill>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column>
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngIf="false" class="hover-show">
          <prism-button icon="download">Download Logs</prism-button>
        </div>
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridDetailTemplate let-dataItem>
      <kendo-splitter orientation="vertical" [style]="{ 'border-style': 'none' }">
        <kendo-splitter-pane class="pane-content" [resizable]="false">
          <div *ngIf="!hasParams(dataItem, 'input') && !hasParams(dataItem, 'output')">No parameters available.</div>
          <div *ngIf="hasParams(dataItem, 'input') || hasParams(dataItem, 'output')" class="mt-3 mb-3 row">
            <div
              *ngIf="hasParams(dataItem, 'input')"
              [ngClass]="hasParams(dataItem, 'output') ? 'col-sm-6' : 'col-sm-12'"
            >
              <ng-container
                *ngTemplateOutlet="
                  paramsList;
                  context: {
                    params: dataItem.jobDtls.inputParams,
                    label: 'Input',
                    jobId: dataItem.jobId,
                  }
                "
              ></ng-container>
            </div>
            <div
              *ngIf="hasParams(dataItem, 'output')"
              [ngClass]="hasParams(dataItem, 'input') ? 'col-sm-6' : 'col-sm-12'"
            >
              <ng-container
                *ngTemplateOutlet="
                  paramsList;
                  context: {
                    params: dataItem.jobDtls.outputParams,
                    label: 'Output',
                    jobId: dataItem.jobId,
                  }
                "
              ></ng-container>
            </div>
          </div>
        </kendo-splitter-pane>
        <kendo-splitter-pane *ngIf="dataItem.jobDtls?.errors?.length > 0" class="pane-content" [resizable]="false">
          <label class="error section-label">Error Message</label>
          <ul class="error">
            <li *ngFor="let error of dataItem.jobDtls?.errors">{{ error }}</li>
          </ul>
        </kendo-splitter-pane>
      </kendo-splitter>
    </ng-template>
    <ng-template kendoPagerTemplate>
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="pageSizes"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>

  <ng-template #paramsList let-params="params" let-label="label" let-jobId="jobId">
    <dl class="kv">
      <dt class="section-label">{{ label }} Parameter Name</dt>
      <dd class="section-label">{{ label }} Parameter Value</dd>
      <ng-container *ngFor="let param of params">
        <dt class="key">{{ param.name }}</dt>
        <dd class="value">
          <ng-container [ngSwitch]="param.type">
            <ng-container *ngSwitchCase="'U'">
              <prism-scheduler-file-download [jobId]="jobId" [docId]="param.value"></prism-scheduler-file-download>
            </ng-container>
            <ng-container *ngSwitchCase="'O'">
              {{ param.value | json }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ param.value }}
            </ng-container>
          </ng-container>
        </dd>
      </ng-container>
    </dl>
  </ng-template>
</div>
